<ng-container *featureToggle="features.TEST_FEATURE_TOGGLE_EVEN">
  <!-- TEST_FEATURE_TOGGLE_EVEN: for testing purposes only, no impact on other elements -->
  <div data-testid="test-feature-toggle-even"></div>
</ng-container>
<ng-container *featureToggle="features.TEST_FEATURE_TOGGLE_ODD">
  <!-- TEST_FEATURE_TOGGLE_ODD: for testing purposes only, no impact on other elements -->
  <div data-testid="test-feature-toggle-odd"></div>
</ng-container>

@if (currentUser()) {
  <ng-container *hasPermissions="platformAdvanced">
    <app-notifications-panel
      data-testid="notifications-panel"
      (getNotifications)="refreshNotifications()"
      [notifications]="notifications()"
      [notificationsLoading]="notificationsLoading()">
    </app-notifications-panel>
  </ng-container>
}

<div class="flex justify-end items-center even-spacing global-right-header">
  @if (!isTabletOrSmaller()) {
    <!-- @ LOCALHOST only -->
    @if (hostname === 'localhost') {
      <span class="flex justify-end items-center flex-[1_1_0%]">
        <app-languages data-testid="language-selector" (languageName)="setLang($event)"></app-languages>
      </span>
    }

    <!-- Organisation -->
    @if (currentUser()) {
      @if (sapIsEnabled$$() || hasNonDemoOrg()) {
        <button
          mat-button
          class="organisation-selector"
          [class.org-name-lg]="lgMedia()"
          [class.org-name-xl]="xlMedia()"
          #organisationPickerTrigger="matMenuTrigger"
          [matMenuTriggerFor]="organisationPicker"
          (menuOpened)="trackOpenOrgSelector()"
          tabindex="0"
          data-testid="organisation-select-button">
          @if (currentOrganisation()) {
            <ng-container [ngTemplateOutlet]="leMdMedia() ? leOrgView : lgOrgView"> </ng-container>
          }
          <span class="organisation-selector-menu-icon ml-1">
            @if (organisationPickerTrigger.menuOpen) {
              <claas-icon iconId="659459" namespace="cc" [size]="24"> </claas-icon>
            } @else {
              <claas-icon iconId="659458" namespace="cc" [size]="24"> </claas-icon>
            }
          </span>
        </button>
      } @else {
        <div class="mx-4 flex">
          <ng-container [ngTemplateOutlet]="leMdMedia() ? leOrgView : lgOrgView"> </ng-container>
        </div>
      }
    }
    <mat-menu #organisationPicker="matMenu" class="org-menu" xPosition="before" backdropClass="pc">
      @if (orgMenuData$$(); as data) {
        @if (!hasNonDemoOrg()) {
          <button
            mat-menu-item
            class="menuButton"
            data-testid="create-organisation"
            tabindex="0"
            (click)="registerOrganisation(data.user, $safeNavigationMigration(data.dialogSteps?.steps))">
            <div class="flex items-center">
              <div class="flex items-center">
                <claas-icon class="add-icon" iconId="648541" namespace="cc" [size]="22"> </claas-icon>
                <span class="create-organization">{{ 'organisationSelector.create' | translate }}</span>
              </div>
            </div>
          </button>
        }
        @for (org of organisations(); track org.id) {
          <button
            mat-menu-item
            class="menuButton"
            [class.activeOrg]="org.auth0Id === currentOrganisation()?.auth0Id"
            [ngClass]="{ 'is-registered-org': org.registered, 'is-demo-org': !org.registered }"
            (click)="setCurrentOrganisation(org)"
            [attr.data-testid]="'organisation-' + org.name | lowercase">
            <div class="flex items-center" tabindex="0">
              <claas-icon
                class="org-selector-farm-icon grid"
                iconName="agricultural_buisness_farm"
                [iconStyle]="'bold'"
                namespace="cc"
                [size]="22"
                [matBadge]="org.notificationCount"
                [matBadgeHidden]="org.notificationCount === 0"
                matBadgeSize="small">
              </claas-icon>
              <span class="organization-name">{{ org.name }}</span>
            </div>
          </button>
        }
        @if (hasNonDemoOrg()) {
          <ng-container *hasPermissions="manageOrgPermission">
            <span class="block my-1"><mat-divider></mat-divider></span>
            <button
              mat-menu-item
              class="menuButton"
              tabindex="1"
              (click)="gotoClaasIdInviteUser()"
              data-testid="invite-user-button">
              <div class="flex items-center">
                <claas-icon class="edit-icon" iconId="750372" namespace="cc" [size]="22"> </claas-icon>
                <span class="manage-organization">{{ 'organisationSelector.invite_user' | translate }}</span>
                <claas-icon [removeDefaultColor]="true" class="open-in-new" iconId="659469" namespace="cc" [size]="16">
                </claas-icon>
              </div>
            </button>
          </ng-container>

          @if (sapIsEnabled$$()) {
            <span class="block my-1"><mat-divider></mat-divider></span>
            <button
              mat-menu-item
              class="menuButton"
              data-testid="create-organisation"
              tabindex="0"
              (click)="registerOrganisation(data.user, $safeNavigationMigration(data.dialogSteps?.steps))">
              <div class="flex items-center">
                <div class="flex items-center">
                  <claas-icon class="add-icon" iconId="648541" namespace="cc" [size]="22"> </claas-icon>
                  <span class="create-organization">{{ 'organisationSelector.new_org' | translate }}</span>
                </div>
              </div>
            </button>
          }
        }
      }
    </mat-menu>

    <ul class="header-icons-list">
      <li class="max-sm:w-7.5">
        <app-help-menu
          data-testid="help-menu-button"
          [currentUser]="currentUser()"
          [currentOrganisation]="currentOrg() ?? null"></app-help-menu>
      </li>
      <li class="max-sm:w-7.5" *hasPermissions="platformAdvanced">
        @if (currentUser()) {
          <div id="notification-menu-button-survey-anchor" class="relative flex top-2.5 right-1"></div>
          <claas-icon-button
            data-testid="notification-menu-button"
            data-notifications-trigger
            (click)="notificationsPanel()?.toggleSidebar()"
            [icon]="{ iconName: 'notification', namespace: 'cc', iconStyle: 'linear' }"
            [iconBadge]="{
              badge: !!newNotificationsCount$$(),
              badgeValue: newNotificationsCount$$() || null,
              badgeVariant: 'error',
              customBadgeClasses: null,
              badgeIcon: null,
              badgeIconSize: 'medium-icon',
              badgeValueLimit: 100,
            }">
          </claas-icon-button>
        }
      </li>
      <ng-container *featureToggle="features.NEW_PARTS_SHOP">
        <li class="max-sm:w-7.5">
          @if (currentUser()) {
            <app-mini-cart></app-mini-cart>
          }
        </li>
      </ng-container>
      <li class="max-sm:w-7.5">
        <!-- App Selector -->
        <claas-icon-button
          data-testid="app-launcher-menu-button"
          tabindex="0"
          [matMenuTriggerFor]="appDrawer"
          (menuOpened)="trackOpenAppSelector()"
          [icon]="{ iconId: '648467', namespace: 'cc', iconStyle: 'bold' }"></claas-icon-button>
      </li>
    </ul>
    <mat-menu #appDrawer="matMenu" class="app-drawer-menu" xPosition="before" backdropClass="pc">
      <app-app-launcher data-testid="app-launcher-panel" class="w-95 block"></app-app-launcher>
    </mat-menu>
    <!-- User -->
    <button
      mat-icon-button
      data-testid="user-profile-button"
      class="user-icon"
      [class.active-user-icon]="desktopUserMenuTrigger.menuOpen"
      #desktopUserMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="headerMenu"
      (menuOpened)="trackOpenAccountMenu()"
      tabindex="0">
      <img [src]="currentUser()?.picture ?? '/assets/icons/icon-user.svg'" class="user-icon-image" alt="user" />
    </button>
  } @else {
    <ng-container *featureToggle="features.NEW_PARTS_SHOP">
      @if (currentUser()) {
        <app-mini-cart></app-mini-cart>
      }
    </ng-container>

    <claas-icon-button
      data-testid="mobile-menu-button"
      [icon]="{ iconId: '648619', namespace: 'cc', iconStyle: 'bold' }"
      class="user-icon ml-2 mr-3"
      [class.active-user-icon]="mobileUserMenuTrigger.menuOpen"
      #mobileUserMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="headerMenu"
      (menuOpened)="trackOpenAccountMenu()"
      tabindex="0"
      [iconBadge]="{
        badge: !!newNotificationsCount$$(),
        badgeValue: newNotificationsCount$$() || null,
        badgeVariant: 'error',
        customBadgeClasses: null,
        badgeIcon: null,
        badgeIconSize: 'medium-icon',
        badgeValueLimit: 100,
      }">
    </claas-icon-button>
  }

  <mat-menu
    #headerMenu="matMenu"
    class="user-menu-container max-sm:fixed! max-sm:inset-0! max-sm:w-screen! max-sm:max-w-none!"
    xPosition="before"
    backdropClass="pc">
    <div data-testid="user-profile-settings-panel">
      <claas-icon-button
        (click)="closeAccountMenu()"
        class="sm:hidden! max-sm:fixed! max-sm:top-2! max-sm:right-2!"
        data-testid="account-menu-close"
        [icon]="{ iconId: '648548', namespace: 'cc', iconStyle: 'linear' }">
      </claas-icon-button>

      <div class="user flex flex-col mt-6 mb-4">
        <span>
          <img
            [src]="currentUser()?.picture ?? '/assets/icons/icon-user.svg'"
            alt="user"
            data-testid="user-profile-image" />
          <span class="heading-h6" data-testid="user-profile-name">
            {{ currentUser()?.user_metadata?.given_name }} {{ currentUser()?.user_metadata?.family_name }}
          </span>
          <span class="mat-body-2 email" data-testid="user-profile-email">{{ currentUser()?.email }}</span>
        </span>
      </div>

      @if (isTabletOrSmaller()) {
        @if (currentUser()) {
          <span class="block my-1"><mat-divider></mat-divider></span>

          <ng-container *hasPermissions="platformAdvanced">
            <button
              mat-menu-item
              class="menu-item"
              (click)="notificationsPanel()?.toggleSidebar()"
              data-notifications-trigger
              data-testid="mobile-notifications-button">
              <span class="flex items-center">
                <claas-icon
                  [badgeVariant]="'error'"
                  [badge]="!!newNotificationsCount$$()"
                  [badgeValue]="newNotificationsCount$$() || null"
                  [badgeValueLimit]="100"
                  [removeDefaultColor]="true"
                  class="user-menu-icon mr-2"
                  iconName="notification"
                  namespace="cc"
                  [size]="22"
                  data-testid="notifications-count">
                </claas-icon>
                <span data-testid="notifications-label">{{ 'navbar.user_menu.notifications' | translate }}</span>
              </span>
            </button>
          </ng-container>
        }

        <span class="block my-1"><mat-divider></mat-divider></span>

        <button mat-menu-item class="menu-item" data-testid="help-center-button" (click)="onHelpCenterClick()">
          <span class="flex items-center">
            <claas-icon
              class="user-menu-icon mr-2"
              [removeDefaultColor]="true"
              iconId="648470"
              namespace="cc"
              [size]="24">
            </claas-icon>
            <span>{{ 'navbar.user_menu.help' | translate }}</span>
          </span>
          <claas-icon
            [removeDefaultColor]="true"
            class="user-menu-icon open-in-new"
            iconId="659469"
            namespace="cc"
            [size]="16">
          </claas-icon>
        </button>

        <button mat-menu-item class="menu-item" data-testid="news-link-button" (click)="onNewsClick()">
          <span class="flex items-center">
            <claas-icon
              badgeVariant="info"
              [badge]="showNewsBadge()"
              [removeDefaultColor]="true"
              class="user-menu-icon mr-2"
              iconId="659500"
              namespace="cc"
              [size]="24">
            </claas-icon>
            <span>{{ 'support.news-link-button' | translate }}</span>
          </span>
          <claas-icon
            [removeDefaultColor]="true"
            class="user-menu-icon open-in-new"
            iconId="659469"
            namespace="cc"
            [size]="16">
          </claas-icon>
        </button>

        <button mat-menu-item class="menu-item" data-testid="contact-support-button" (click)="onSupportFormClick()">
          <span class="flex items-center">
            <claas-icon
              class="user-menu-icon mr-2"
              [removeDefaultColor]="true"
              iconId="750380"
              namespace="cc"
              [size]="24">
            </claas-icon>
            <span>{{ 'navbar.user_menu.contact' | translate }}</span>
          </span>
        </button>

        <button
          mat-menu-item
          class="menu-item"
          data-testid="invite-support-button"
          (click)="onInviteTempSupportClick()">
          <span class="flex items-center">
            <claas-icon
              class="user-menu-icon mr-2"
              [removeDefaultColor]="true"
              iconId="795311"
              namespace="cc"
              [size]="24">
            </claas-icon>
            <span>{{ 'support.support_invite' | translate }}</span>
          </span>
          <claas-icon
            [removeDefaultColor]="true"
            class="user-menu-icon open-in-new"
            iconId="659469"
            namespace="cc"
            [size]="16">
          </claas-icon>
        </button>

        <span class="block my-1"><mat-divider></mat-divider></span>

        <button
          mat-menu-item
          class="menu-item"
          data-testid="app-launcher-menu-button-mobile"
          (click)="openAppDrawerDialog()">
          <span class="flex items-center">
            <claas-icon
              class="user-menu-icon mr-2"
              [removeDefaultColor]="true"
              iconId="648467"
              namespace="cc"
              [size]="24">
            </claas-icon>
            <span>{{ 'navbar.user_menu.claas_apps' | translate }}</span>
          </span>
        </button>

        <span class="block my-1"><mat-divider></mat-divider></span>

        @if (orgMenuData$$(); as data) {
          <ng-template #createOrgMobileButton let-labelKey="labelKey">
            <button
              mat-menu-item
              class="menu-item"
              data-testid="create-organisation-mobile"
              (click)="registerOrganisation(data.user, $safeNavigationMigration(data.dialogSteps?.steps))">
              <span class="flex items-center">
                <claas-icon
                  class="user-menu-icon mr-2"
                  [removeDefaultColor]="true"
                  iconId="648541"
                  namespace="cc"
                  [size]="24">
                </claas-icon>
                <span>{{ labelKey | translate }}</span>
              </span>
            </button>
          </ng-template>

          @if (!hasNonDemoOrg()) {
            <ng-container
              [ngTemplateOutlet]="createOrgMobileButton"
              [ngTemplateOutletContext]="{ labelKey: 'organisationSelector.create' }">
            </ng-container>
          }

          @if (sapIsEnabled$$() || hasNonDemoOrg()) {
            <button
              mat-menu-item
              class="menu-item"
              data-testid="change-organisation-menu-button-mobile"
              (click)="openChangeOrganisationDialog()">
              <span class="flex items-center">
                <claas-icon
                  class="user-menu-icon mr-2"
                  [removeDefaultColor]="true"
                  iconName="agricultural_buisness_farm"
                  namespace="cc"
                  [size]="24">
                </claas-icon>
                <span>{{ 'navbar.user_menu.change_organisation' | translate }}</span>
              </span>
            </button>
          }

          @if (hasNonDemoOrg()) {
            <ng-container *hasPermissions="manageOrgPermission">
              <button
                mat-menu-item
                class="menu-item"
                data-testid="invite-user-button"
                (click)="gotoClaasIdInviteUser()">
                <span class="flex items-center">
                  <claas-icon
                    class="user-menu-icon mr-2"
                    [removeDefaultColor]="true"
                    iconId="750372"
                    namespace="cc"
                    [size]="24">
                  </claas-icon>
                  <span class="manage-organization">{{ 'organisationSelector.invite_user' | translate }}</span>
                  <claas-icon
                    [removeDefaultColor]="true"
                    class="user-menu-icon open-in-new"
                    iconId="659469"
                    namespace="cc"
                    [size]="16">
                  </claas-icon>
                </span>
              </button>
            </ng-container>

            @if (sapIsEnabled$$()) {
              <ng-container
                [ngTemplateOutlet]="createOrgMobileButton"
                [ngTemplateOutletContext]="{ labelKey: 'organisationSelector.new_org' }">
              </ng-container>
            }
          }
        }
      }

      <span class="block my-1"><mat-divider></mat-divider></span>

      <button
        mat-menu-item
        (click)="onClaasIdSettings('personal-data')"
        class="claas-id"
        data-testid="personal-data-settings-button">
        <span class="flex items-center">
          <claas-icon
            class="user-menu-icon mr-2"
            [removeDefaultColor]="true"
            iconId="648427"
            namespace="cc"
            [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.personal_data' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <button
        mat-menu-item
        (click)="onClaasIdSettings('user-settings')"
        class="claas-id"
        data-testid="user-settings-button">
        <span class="flex items-center">
          <claas-icon
            class="user-menu-icon mr-2"
            [removeDefaultColor]="true"
            iconId="648466"
            namespace="cc"
            [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.user_settings' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <button
        mat-menu-item
        (click)="onClaasIdSettings('organisations')"
        class="claas-id"
        data-testid="organisation-settings-button">
        <span class="flex items-center">
          <claas-icon
            class="user-menu-icon mr-2"
            [removeDefaultColor]="true"
            iconId="783207"
            namespace="cc"
            [size]="24">
          </claas-icon>
          <span>{{ 'navbar.user_menu.manage_claas_id.organisation_settings' | translate }}</span>
        </span>
        <claas-icon
          [removeDefaultColor]="true"
          class="user-menu-icon open-in-new"
          iconId="659469"
          namespace="cc"
          [size]="16">
        </claas-icon>
      </button>

      <span class="block my-1"><mat-divider></mat-divider></span>

      <div class="logout">
        <claas-button
          data-testid="logout-button"
          class="w-full"
          buttonClass="secondaryOutline"
          [stretch]="true"
          (click)="onLogout()"
          ><claas-icon iconId="659471" namespace="cc" iconStyle="bold" />{{ 'navbar.logout' | translate }}
        </claas-button>
      </div>
      <div class="links">
        @if (legalTextLinks$$()) {
          @for (legalTextLink of legalTextLinks$$(); track legalTextLink.link) {
            <a [href]="legalTextLink.link" target="_blank" [attr.data-testid]="'legal-link-' + $index">
              {{ legalTextLink.label | translate }}
            </a>
          }
        }

        <a onclick="UC_UI.showSecondLayer()" data-testid="privacy-link">
          {{ 'navbar.privacy' | translate }}
        </a>
        <a
          *featureToggle="features.EUROPEAN_DATA_ACT_EXPORT"
          href="{{ dataActLink$$() }}"
          target="_blank"
          data-testid="data-act-link">
          {{ 'navbar.data_act' | translate }}
        </a>
      </div>
    </div>
  </mat-menu>
</div>

<ng-template #lgOrgView>
  <span
    [matBadge]="getAllNotificationsCount()"
    [matBadgeHidden]="getAllNotificationsCount() == 0"
    class="username hide-text"
    matBadgeOverlap="false"
    matBadgeSize="small">
    <span class="org-name" data-testid="current-organisation-name">{{ currentOrganisation()?.name }}</span>
  </span>
</ng-template>

<ng-template #leOrgView>
  <claas-icon
    [matBadge]="getAllNotificationsCount()"
    [matBadgeHidden]="getAllNotificationsCount() == 0"
    class="org-selector-farm-icon ml-2"
    iconName="agricultural_buisness_farm"
    [iconStyle]="'bold'"
    namespace="cc"
    [size]="22"
    matBadgeSize="small"
    data-testid="notification-menu-button">
  </claas-icon>
</ng-template>
